import React from 'react';
import { motion } from 'framer-motion';
import { QrCode, SplitSquareHorizontal, Mail } from 'lucide-react';
import { InteriorSlide, SlideHeader, SlideBanner } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide05Benefits({
  index
}: SlideProps) {
  const fixes = [{
    icon: QrCode,
    title: 'QR → Trailer Bridge',
    text: 'Deploy QR codes directly to the trailer Snak — not just the teaser. You confirmed QR is the #1 channel. We extend it immediately to capture the conversion gap.',
    delay: 0.4
  }, {
    icon: SplitSquareHorizontal,
    title: 'Post-Quiz Follow-Up',
    text: '50% of HCPs showed awareness gaps on new adjuvant. We build a simple fork: those who answer wrong get a follow-up Snak. Small change, big impact on retention.',
    delay: 0.55
  }, {
    icon: Mail,
    title: 'Direct Email Blast',
    text: 'Bypass the teaser entirely. Send HCPs straight to the trailer with a clean, mobile-optimised email. Reduce friction. Increase conversion.',
    delay: 0.7
  }];
  return <InteriorSlide banner={<SlideBanner eyebrow="Immediate — This Month" data-id="element-106">
          These three fixes cost nothing to delay — but every week without them
          is data and engagement lost.
        </SlideBanner>} data-id="element-105">
      <SlideHeader eyebrow="First: Fix Phesgo Now" data-id="element-107">
        Three quick wins. One fixed fee.
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-6xl mx-auto w-full" data-id="element-108">
        {/* Left: Visual */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="flex-1 w-full relative aspect-[4/5] max-w-md rounded-3xl overflow-hidden shadow-2xl border-8 border-white" data-id="element-109">
          <img src="https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=1200&q=80" alt="African healthcare worker using a smartphone" className="w-full h-full object-cover" data-id="element-110" />
          <div className="absolute inset-0 bg-gradient-to-t from-[var(--brand)]/80 via-transparent to-transparent mix-blend-multiply" data-id="element-111" />
          <div className="absolute bottom-0 left-0 right-0 p-8 text-center" data-id="element-112">
            <div className="bg-white/90 backdrop-blur-sm text-[var(--brand)] px-8 py-4 rounded-2xl shadow-lg inline-block" data-id="element-113">
              <div className="text-sm font-bold uppercase tracking-widest opacity-80 mb-1" data-id="element-114">
                All in
              </div>
              <div className="text-4xl font-extrabold" data-id="element-115">€3,500</div>
            </div>
          </div>
        </motion.div>

        {/* Right: Content */}
        <div className="flex-1 space-y-8 w-full" data-id="element-116">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed" data-id="element-117">
            The phone is the most powerful asset in Africa. Everything we build
            is designed for it. Let's start by fixing the immediate gaps in the
            Phesgo campaign.
          </motion.p>

          <div className="space-y-4" data-id="element-118">
            {fixes.map((fix, i) => {
            const Icon = fix.icon;
            return <motion.div key={fix.title} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: fix.delay,
              duration: 0.6
            }} className="bg-white rounded-2xl p-6 shadow-sm border border-black/5 flex items-start gap-4" data-id="element-119">
                  <div className="h-10 w-10 rounded-xl bg-[var(--surface)] flex items-center justify-center flex-shrink-0 text-[var(--brand)]" data-id="element-120">
                    <Icon className="h-5 w-5" data-id="element-121" />
                  </div>
                  <div data-id="element-122">
                    <h3 className="text-lg font-bold text-[var(--fg)] mb-1" data-id="element-123">
                      {fix.title}
                    </h3>
                    <p className="text-[var(--muted)] text-sm leading-relaxed" data-id="element-124">
                      {fix.text}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </InteriorSlide>;
}